import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    Input,
    InputLabel,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField
} from "@mui/material";
import * as React from "react";
import { IapSelector } from "../iap";
import { IPackItem } from "../Items/item";
import { PackItems } from "../Items/items";
import { Condition } from "./condition";
import { OfferPackCondition, OfferPackItem } from "./index";

interface OfferPackEntryProps {
    entry: any;
    classes: any;

    onRemove(item: OfferPackItem);

    onUpdate(item: OfferPackItem);
}

interface OfferPackEntryState {
    entry: OfferPackItem;

    modalVisible: boolean;
}

export class OfferPackEntry extends React.Component<OfferPackEntryProps, OfferPackEntryState> {

    constructor(props: OfferPackEntryProps) {
        super(props);

        this.state = {
            entry: {
                id: this.props.entry.id,
                packageId: this.props.entry.packageId,
                title: this.props.entry.title,
                subtitle: this.props.entry.subtitle,
                button: this.props.entry.button,

                googleId: this.props.entry.googleId,
                appleId: this.props.entry.appleId,
                samsungId: this.props.entry.samsungId,
                huaweiId: this.props.entry.huaweiId,

                category: this.props.entry.category,
                bonusValue: parseFloat((this.props.entry.bonusValue * 100).toFixed(2)),

                expire: this.props.entry.expire,
                limit: this.props.entry.limit,

                conditions: this.props.entry.conditions || [],

                validatePayment: this.props.entry.validatePayment,
                deleteExpired: this.props.entry.deleteExpired,

                items: this.props.entry.items,

                badgeColor: this.props.entry.badgeColor || "",
                isSpecial: this.props.entry.isSpecial || false,
                prefab: this.props.entry.prefab || "",
                extraValue: this.props.entry.extraValue || null,

                desc: {
                    type: this.props.entry.desc?.type || null,
                    level: this.props.entry.desc?.level || null
                },

                images: {
                    icon: this.props.entry.images?.icon || null,
                    background: this.props.entry.images?.background || null
                }
            },

            modalVisible: false
        };
    }

    onValueChange = (key: keyof OfferPackItem | string, type: "string" | "numeric" | "bool" | "color", value: any) => {
        this.setState(state => {
            switch (type) {
                case "string":
                    value = String(value);
                    break;
                case "numeric":
                    value = +value;
                    break;
                case "bool":
                    value = value === "true";
                    break;
                case "color":
                    value = value.replace("#", "");
                    break;
                default:
            }

            if (key.includes(".")) {
                const [parentKey, childKey] = key.split(".");

                state.entry[parentKey][childKey] = value;
            } else {
                state.entry[key] = value as never;
            }

            return state;
        }, () => {
            this.props.onUpdate({
                ...this.state.entry,
                bonusValue: this.state.entry.bonusValue / 100
            });
        });
    };

    onIapChange = (key: keyof OfferPackItem, item) => {
        this.onValueChange(key, "string", item.productId);
    };

    remove = () => {
        if (!confirm("Are you sure you want to delete this Offer Pack?")) {
            return;
        }

        this.props.onRemove(this.state.entry);
    };

    edit = () => {
        this.setState({
            modalVisible: true
        });
    };

    updateItems = (items: IPackItem[]) => {
        const entry = {...this.state.entry};

        entry.items = items;

        this.setState({
            entry
        }, () => {
            this.props.onUpdate({
                ...this.state.entry,
                bonusValue: this.state.entry.bonusValue / 100
            });
        });
    };

    addCondition = () => {
        this.setState(state => {
            state.entry.conditions.push({
                condition: "",
                operator: "==",
                value: "",
                secondValue: null
            });

            return state;
        });
    };

    removeCondition = (index: number) => {
        this.setState(state => {
            state.entry.conditions.splice(index, 1);

            return state;
        });
    };

    updateCondition = (index: number, condition: OfferPackCondition) => {
        this.setState(state => {
            state.entry.conditions[index] = condition;

            return state;
        });
    };

    render() {
        return <TableRow
            key={this.state.entry.id}
            hover={true}
            className={this.props.classes.tableRow}
        >
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.entry.packageId}
                       onChange={(e) => this.onValueChange("packageId", "string", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.entry.title}
                       onChange={(e) => this.onValueChange("title", "string", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.entry.subtitle}
                       onChange={(e) => this.onValueChange("subtitle", "string", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.entry.button}
                       onChange={(e) => this.onValueChange("button", "string", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" type="number" value={this.state.entry.bonusValue}
                       onChange={(e) => this.onValueChange("bonusValue", "numeric", e.target.value)}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" type="number" value={this.state.entry.limit}
                       onChange={(e) => this.onValueChange("limit", "numeric", e.target.value)}/>
            </TableCell>
            <TableCell>
                <Select value={this.state.entry.validatePayment} size="small"
                        onChange={(e) => this.onValueChange("validatePayment", "bool", e.target.value)}>
                    <MenuItem value={"true"}>Yes</MenuItem>
                    <MenuItem value={"false"}>No</MenuItem>
                </Select>
            </TableCell>
            <TableCell>
                <Grid container spacing={2}>
                    <Grid item>
                        <Button disableElevation onClick={this.edit} size="small">
                            <EditIcon color={"primary"}/>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button disableElevation onClick={this.remove} size="small">
                            <DeleteForeverIcon color={"error"}/>
                        </Button>
                    </Grid>
                </Grid>
            </TableCell>

            <Dialog
                open={this.state.modalVisible}
                onClose={() => this.setState({modalVisible: false})}
                fullWidth={true}
                maxWidth={"md"}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Edit {this.state.entry.packageId}
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <h3>IAP</h3>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.googleId} platform={"ios/android"} label={"Google ID"}
                                     onChange={(_e, item) => this.onIapChange("googleId", item)}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.appleId} platform={"ios/android"} label={"Apple ID"}
                                     onChange={(_e, item) => this.onIapChange("appleId", item)}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.samsungId} platform={"udp"} label={"Samsung ID"}
                                     onChange={(_e, item) => this.onIapChange("samsungId", item)}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.huaweiId} platform={"udp"} label={"Huawei ID"}
                                     onChange={(_e, item) => this.onIapChange("huaweiId", item)}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20, marginTop: 20}}>
                        <h3>Configuration</h3>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <TextField value={this.state.entry.expire}
                                   label={"Expire time (DD-MM-YYYY or seconds)"}
                                   onChange={(e) => this.onValueChange("expire", "string", e.target.value)}
                                   style={{width: "100%"}}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <TextField value={this.state.entry.badgeColor ? "#" + this.state.entry.badgeColor : null}
                                   type={"color"}
                                   label={"Badge Color"}
                                   onChange={(e) => this.onValueChange("badgeColor", "color", e.target.value)}
                                   style={{width: "100%"}}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <TextField value={this.state.entry.extraValue}
                                   label={"Extra Value"}
                                   onChange={(e) => this.onValueChange("extraValue", "string", e.target.value)}
                                   style={{width: "100%"}}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <InputLabel>Prefab</InputLabel>
                        <Select value={this.state.entry.prefab}
                                onChange={(e) => this.onValueChange("prefab", "string", e.target.value)}>
                            <MenuItem value={"noob_pack"}>noob_pack</MenuItem>
                            <MenuItem value={"core_pack"}>core_pack</MenuItem>
                            <MenuItem value={"league_pack"}>league_pack</MenuItem>
                            <MenuItem value={"vip_pack"}>vip_pack</MenuItem>
                            <MenuItem value={"special_pack"}>special_pack</MenuItem>
                        </Select>
                    </FormControl>

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <FormControl required fullWidth style={{marginBottom: 20}}>
                                <InputLabel>Is Special?</InputLabel>
                                <Select value={this.state.entry.isSpecial}
                                        fullWidth
                                        onChange={(e) => this.onValueChange("isSpecial", "bool", e.target.value)}>
                                    <MenuItem value={"true"}>Yes</MenuItem>
                                    <MenuItem value={"false"}>No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl required fullWidth style={{marginBottom: 20}}>
                                <InputLabel>Delete Expired?</InputLabel>
                                <Select value={this.state.entry.deleteExpired}
                                        fullWidth
                                        onChange={(e) => this.onValueChange("deleteExpired", "bool", e.target.value)}>
                                    <MenuItem value={"true"}>Yes</MenuItem>
                                    <MenuItem value={"false"}>No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <FormControl required fullWidth style={{marginBottom: 20}}>
                                <TextField value={this.state.entry.desc.type}
                                           label={"Description Type"}
                                           onChange={(e) => this.onValueChange("desc.type", "string", e.target.value)}
                                           style={{width: "100%"}}/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl required fullWidth style={{marginBottom: 20}}>
                                <TextField value={this.state.entry.desc.level}
                                           label={"Description Level"}
                                           onChange={(e) => this.onValueChange("desc.level", "string", e.target.value)}
                                           style={{width: "100%"}}/>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <FormControl required fullWidth style={{marginBottom: 20}}>
                                <TextField value={this.state.entry.images.icon}
                                           label={"Icon Image"}
                                           onChange={(e) => this.onValueChange("images.icon", "string", e.target.value)}
                                           style={{width: "100%"}}/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl required fullWidth style={{marginBottom: 20}}>
                                <TextField value={this.state.entry.images.background}
                                           label={"Background Image"}
                                           onChange={(e) => this.onValueChange("images.background", "string", e.target.value)}
                                           style={{width: "100%"}}/>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <FormControl required fullWidth style={{marginBottom: 20, marginTop: 20}}>
                        <h3>Conditions</h3>
                    </FormControl>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Condition</TableCell>
                                <TableCell>Operator</TableCell>
                                <TableCell>Value</TableCell>
                                <TableCell style={{width: 40}}/>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.entry.conditions.map((condition, index) =>
                                <Condition entry={condition} index={index} key={index}
                                           onRemove={this.removeCondition}
                                           onUpdate={this.updateCondition}/>)}
                        </TableBody>
                    </Table>

                    <FormControl style={{margin: 24}}>
                        <Button disableElevation onClick={this.addCondition} color="primary" size="small"
                                variant="contained">
                            Add
                        </Button>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20, marginTop: 20}}>
                        <h3>Items</h3>
                    </FormControl>

                    <PackItems list={this.state.entry.items} onUpdate={this.updateItems}/>
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={() => this.setState({modalVisible: false})} color="primary" variant="contained" size="small">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </TableRow>;
    }
}
